/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AddressClassification {
  COMMERCIAL = 'COMMERCIAL',
  MILITARY = 'MILITARY',
  RESIDENTIAL = 'RESIDENTIAL',
  UNKNOWN = 'UNKNOWN',
}

export enum AddressHomeSize {
  four_bed_plus = 'four_bed_plus',
  one_bed = 'one_bed',
  studio = 'studio',
  three_bed = 'three_bed',
  three_bed_plus = 'three_bed_plus',
  two_bed = 'two_bed',
}

export enum AddressStatus {
  APT_NEEDED = 'APT_NEEDED',
  INVALID = 'INVALID',
  VALID = 'VALID',
}

export enum InstallationOptionsEnum {
  professional = 'professional',
  self = 'self',
}

export enum InternetProductType {
  bpl = 'bpl',
  cable = 'cable',
  dsl = 'dsl',
  fiber = 'fiber',
  satellite = 'satellite',
  wireless = 'wireless',
}

export enum PhoneProductType {
  cable = 'cable',
  fiber = 'fiber',
  landline = 'landline',
  satellite = 'satellite',
  voip = 'voip',
}

export enum ServiceabilityCachingStrategy {
  aggressive = 'aggressive',
  conservative = 'conservative',
  none = 'none',
}

export enum ServiceabilityChargeType {
  activation = 'activation',
  early_cancellation = 'early_cancellation',
  installation = 'installation',
  long_term = 'long_term',
  short_term = 'short_term',
}

export enum ServiceabilityDisclaimerDisplayLocation {
  details = 'details',
  list_page = 'list_page',
  proximity = 'proximity',
}

export enum ServiceabilityInternetSpeedUnit {
  gbps = 'gbps',
  kbps = 'kbps',
  mbps = 'mbps',
}

export enum ServiceabilityProviderAvailability {
  available = 'available',
  unavailable = 'unavailable',
  unknown = 'unknown',
}

export enum ServiceabilityResultStatus {
  cache = 'cache',
  error = 'error',
  ok = 'ok',
}

export enum ServiceabilityTermUnit {
  month = 'month',
  year = 'year',
}

export enum SortOrder {
  asc = 'asc',
  desc = 'desc',
}

export enum SortableField {
  revenueRanking = 'revenueRanking',
}

export enum TvProductType {
  cable = 'cable',
  fiber = 'fiber',
  iptv = 'iptv',
  satellite = 'satellite',
}

export interface AddressInput {
  city: string;
  homeSize?: AddressHomeSize | null;
  postalCode: string;
  state: string;
  street: string;
  unit?: string | null;
}

export interface AvailableOffersInput {
  moveId?: string | null;
  address?: AddressInput | null;
  providerCodes?: (string | null)[] | null;
  cachingStrategy?: ServiceabilityCachingStrategy | null;
  experiments?: (Experiment | null)[] | null;
  source?: string | null;
  optionalFields?: OptionalFields | null;
  promoId?: string | null;
  skipAddressNormalization?: boolean | null;
  sort?: Sort[] | null;
}

export interface CreateLeadInput {
  requestId: string;
  offer: OfferInput;
  customerInformation: CustomerInformationInput;
}

export interface CreatePublicSessionInput {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  source?: string | null;
}

export interface CustomerInformationInput {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface DcSessionInput {
  requestId: string;
}

export interface Experiment {
  name: string;
  variationKey: string;
}

export interface OfferInput {
  code?: string | null;
  providerCode?: string | null;
}

export interface OptionalFields {
  uuid?: string | null;
  gclid?: string | null;
  msclkid?: string | null;
  fbclid?: string | null;
}

export interface Sort {
  field?: SortableField | null;
  order?: SortOrder | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
